// ============================================
// INFRASTRUCTURE - Cupón Pendiente Storage
// ============================================
// Persiste el cupón aplicado en el flujo de "Registrar Tarjeta" para que
// sobreviva la redirección a Flow y pueda enviarse al crear la suscripción
// cuando el usuario regresa a la aplicación.

const STORAGE_KEY = 'ad_premium_cupon_pendiente';

export interface CuponPendiente {
  cuponId: number;
  codigo: string;
}

export const cuponPendienteStorage = {
  guardar(cupon: CuponPendiente): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cupon));
    } catch (error) {
      console.error('No se pudo guardar el cupón pendiente:', error);
    }
  },

  obtener(): CuponPendiente | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as CuponPendiente) : null;
    } catch (error) {
      console.error('No se pudo leer el cupón pendiente:', error);
      return null;
    }
  },

  limpiar(): void {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('No se pudo limpiar el cupón pendiente:', error);
    }
  },
};
